module.exports = __webpack_public_path__ + "components/alert-table/static/icon-checkbox-0b1a8ef5aa98a2741fff476346fc908f.svg";